// Credits
import '/src/js/core/credits.js';

// Dynamic header
//import '/src/js/components/dynamic-header.js';

// Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// CSS
import '/src/sass/main.scss';
